import ProjectHeroCoffeeShop from "../../../components/ProjectHero/CoffeeShop/ProjectHeroCoffeeShop";
import ProjectDetailsCoffeeShop from "../../../components/ProjectDetails/CoffeeShop/ProjectDetailsCoffeeShop";


function ProjectPageCoffeeShop() {
    return (
        <>
            <ProjectHeroCoffeeShop />
            <ProjectDetailsCoffeeShop />
        </>
    )
}

export default ProjectPageCoffeeShop;